import { Component, EventEmitter, OnInit, Input, Output, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { Router }            from '@angular/router';
import { AppModule }              from '../app.module';


import * as ent from '../entities/index'
import * as enums from '../enums/index'
import * as filters from '../filters/index'
import * as serv from '../services/index'
import * as util from '../util/index'

//components
import {AttachmentsComponent} from '../components/ControlGroups/Attachments.component';
import {GeneralDetailsComponent} from '../components/ControlGroups/GeneralDetails.component';
import {ContactDetailsComponent} from '../components/ControlGroups/ContactDetails.component';
import {CustomerRequirementsComponent} from '../components/ControlGroups/CustomerRequirements.component';
import {RemovalDetailsComponent} from '../components/ControlGroups/RemovalDetails.component';
import {CoolerDetailsComponent} from '../components/ControlGroups/CoolerDetails.component';
import {VendorDetailsComponent} from '../components/ControlGroups/VendorDetails.component';
import {FountainDetailsComponent} from '../components/ControlGroups/FountainDetails.component';
import {NotesComponent} from '../components/ControlGroups/Notes.component';

import {RequestHeaderComponent} from '../components/Controls/RequestHeader.component';

//base
import { BaseControlGroupComponent } from './BaseControlGroup.component';
import BaseRequestComponent from './BaseRequest.component';
import { BillingAddressComponent, PayerContactSelectorComponent } from '../components';

export class BaseNewOutletRequestComponent extends BaseRequestComponent implements OnInit{
    @ViewChild(AttachmentsComponent) attachmentsComponent: AttachmentsComponent;
    @ViewChild(RequestHeaderComponent) requestHeaderComponent: RequestHeaderComponent;
    @ViewChild(GeneralDetailsComponent) generalDetailsComponent: GeneralDetailsComponent;
    @ViewChild(ContactDetailsComponent) contactDetailsComponent: ContactDetailsComponent;
    @ViewChild(BillingAddressComponent) billingAddressComponent: BillingAddressComponent;
    @ViewChild(PayerContactSelectorComponent) payerContactSelectorComponent: PayerContactSelectorComponent;
    @ViewChildren(BaseControlGroupComponent) controlGroups: QueryList<BaseControlGroupComponent>;
    openRequestTab: EventEmitter<Request>;
    request: ent.Request;
    public requestID: number;
    public salesOffice: ent.SalesOffice;
    userInfo: ent.UserInfo;
    appConfig: ent.AppConfig;
    protected authenticationService: serv.AuthenticationService;
    protected requestService: serv.RequestService; 
    protected domainDataService: serv.DomainDataService; 
    protected configService: serv.ConfigService; 
    protected router: Router;
    hideSalesAndDeliveryOnMaintainCustomer: boolean;

    ngOnInit() {};

    ngAfterViewInit(): void{

        super.ngAfterViewInit();
    }   
     
    onCopyOverallAccountPhoneNumberCopiedFromContactDetailsSection(checked: boolean){
        if(checked){
            var overallAccountPhoneNumber = this.generalDetailsComponent.generalInfo.OverallAccountPhoneNumber;
            if (this.contactDetailsComponent.showMultiple) {
                this.contactDetailsComponent.contactGridComponent.recordEditComponent.contactInfo.ContactPhoneNumber = overallAccountPhoneNumber;
            }
            else {
                this.contactDetailsComponent.contactInfo.ContactPhoneNumber = overallAccountPhoneNumber;
                
            }
        } else {
            if (this.contactDetailsComponent.showMultiple) {
                this.contactDetailsComponent.contactGridComponent.recordEditComponent.contactInfo.ContactPhoneNumber = null;
            }
            else {
                this.contactDetailsComponent.contactInfo.ContactPhoneNumber = null;
            }
        }
    }

    onCopyOverallAccountPhoneNumberCopiedFromBillingAddressSection(checked: boolean){
        var overallAccountPhoneNumber = this.billingAddressComponent.billingInfo.PhoneNumber;
        if(checked){
            this.payerContactSelectorComponent.contactEditComponent.contactInfo.ContactPhoneNumber = overallAccountPhoneNumber;
        }else{
            this.payerContactSelectorComponent.contactEditComponent.contactInfo.ContactPhoneNumber = null;
        }
    }

    onCopyOverallAccountEmailCopiedFromContactDetailsSection(checked: boolean){
        if(checked){
            var overallAccountEmail = this.generalDetailsComponent.generalInfo.Email;
            if (this.contactDetailsComponent.showMultiple) {
                this.contactDetailsComponent.contactGridComponent.recordEditComponent.contactInfo.Email = overallAccountEmail;
            }
            else {
                this.contactDetailsComponent.contactInfo.Email = overallAccountEmail;
            }
            
        }else{
            if (this.contactDetailsComponent.showMultiple) {
                this.contactDetailsComponent.contactGridComponent.recordEditComponent.contactInfo.Email = null;
            }
            else
            {
                this.contactDetailsComponent.contactInfo.Email = null;
            }
        }
    }

    onCopyOverallAccountEmailCopiedFromBillingAddressSection(checked: boolean){
        var overallAccountEmail = this.billingAddressComponent.billingInfo.Email;
        if(checked){
            this.payerContactSelectorComponent.contactEditComponent.contactInfo.Email = overallAccountEmail;
        }else{
            this.payerContactSelectorComponent.contactEditComponent.contactInfo.Email = null;
        }
    }

    subscribeToOverallAccountCopyMethodsInContactDetailsSection(){
        this.contactDetailsComponent.contactGridComponent.recordEditComponent.copyOverallAccountPhoneNumberCopied.subscribe((checked: boolean) => 
            {
                this.onCopyOverallAccountPhoneNumberCopiedFromContactDetailsSection(checked);
            });
        this.contactDetailsComponent.contactGridComponent.recordEditComponent.copyOverallAccountEmailCopied.subscribe((checked: boolean) =>
            {
                this.onCopyOverallAccountEmailCopiedFromContactDetailsSection(checked);
            });
    }

    subscribeToOverallAccountCopyMethodsInBillingAddressSection(){
        if (this.payerContactSelectorComponent && this.payerContactSelectorComponent.contactEditComponent) {
            this.payerContactSelectorComponent.contactEditComponent.copyOverallAccountPhoneNumberCopied.subscribe((checked: boolean) => 
                {
                    this.onCopyOverallAccountPhoneNumberCopiedFromBillingAddressSection(checked);
                });
            this.payerContactSelectorComponent.contactEditComponent.copyOverallAccountEmailCopied.subscribe((checked: boolean) =>
                {
                    this.onCopyOverallAccountEmailCopiedFromBillingAddressSection(checked);
                });    
        }
    }
        
}

export default BaseNewOutletRequestComponent;